// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1n1FT","file":"styles_file__xZ3xP"};